import * as React from 'react';
// @ts-ignore
import { Transition } from 'react-spring';
import { ZIndexProps } from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { H3, H4, Span } from '../../../typography';
import Flex from '../Flex';
import Spacer from '../Spacer';
import { CloseButton, ModalBodyCont, ModalFooterCont, ModalHeaderCont, ModalInner, ModalWrap } from './Elements';

const MODAL_ANIM_CONFIG = {
  duration: 250,
  tension: 100,
  friction: 10,
};

type ModalProps = StyledSystemProps &
  ZIndexProps & {
    body?: string;
    error?: string;
    open: boolean;
    heading?: string;
    actions?: React.ReactNode;
    onClick?: () => void;
    onClose: () => void;
    //zIndex?: number;
    bodyOverflowVisible?: boolean;
    overflowXVisible?: boolean;
    subHeading?: string;
    description?: string;
    children?: any;
  };

type ModalState = {
  open: boolean;
};

class Modal extends React.Component<ModalProps, ModalState> {
  static defaultProps = {
    heading: 'Modal Heading',
    body: 'Modal Body',
    onClose: () => null,
    bg: 'white',
    p: 4,
  };

  constructor(props: ModalProps) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  _renderContent() {
    const {
      children,
      error,
      heading,
      body,
      onClose,
      actions,
      bodyOverflowVisible,
      overflowXVisible,
      subHeading,
      description,
    } = this.props;
    const hasAction = !!actions;
    const hasBody = !!body;

    if (children) {
      return (
        <React.Fragment>
          <ModalHeaderCont>
            <H3 style={{ margin: 4 }}>{heading}</H3>
            <CloseButton onClick={onClose} />
            {subHeading && <H4 style={{ margin: 3, color: '#222429' }}>{subHeading}</H4>}
            {description && <H4 style={{ margin: 3, color: '#222429' }}>{description}</H4>}
          </ModalHeaderCont>
          <ModalBodyCont
            style={{
              ...(bodyOverflowVisible && { overflowX: 'visible', overflowY: 'visible' }),
              ...(overflowXVisible && { overflowX: 'visible' }),
            }}
          >
            {children}
          </ModalBodyCont>
          {actions && <ModalFooterCont>{actions}</ModalFooterCont>}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ModalHeaderCont hasBody={hasBody}>
          <H3 style={{ margin: 4 }}>{heading}</H3>
          <CloseButton onClick={onClose} />
          {subHeading && <H4 style={{ margin: 3, color: '#222429' }}>{subHeading}</H4>}
          {description && <H4 style={{ margin: 3, color: '#222429' }}>{description}</H4>}
        </ModalHeaderCont>
        <ModalBodyCont hasAction={!hasAction}>
          <Flex size="1" direction="column">
            <Spacer spacing={10} />
            <Flex size="1" direction="row">
              <Span>{body}</Span>
            </Flex>
            {!!error && (
              <React.Fragment>
                <Spacer spacing={20} />
                <Flex size="1" direction="row">
                  <Span color={'error'}>{error}</Span>
                </Flex>
              </React.Fragment>
            )}
          </Flex>
        </ModalBodyCont>
        {actions && <ModalFooterCont>{actions}</ModalFooterCont>}
      </React.Fragment>
    );
  }

  render() {
    const {
      children,
      open,
      zIndex,
      height,
      width,
      justifyContent,
      bodyOverflowVisible,
      overflowXVisible,
      ...propsrest
    } = this.props;
    const hasChildren = !!children;
    const zIndexValue = zIndex ? parseInt(zIndex.valueOf().toString()) : undefined;
    const heightValue = height ? height.valueOf() : undefined;
    const widthValue = width ? width.valueOf() : undefined;
    const justifyContentValue = justifyContent ? justifyContent.valueOf() : undefined;

    return (
      <Transition
        items={open}
        native={true}
        config={MODAL_ANIM_CONFIG}
        from={{
          opacity: 0,
          transform: 'translateY(40px)',
        }}
        enter={{
          opacity: 1,
          transform: 'translateY(0)',
        }}
        leave={{
          opacity: 0,
          transform: 'translateY(40px)',
          pointerEvents: 'none',
        }}
      >
        {(modalOpen: any) =>
          modalOpen &&
          ((styleProps: any) => (
            <ModalWrap style={{ opacity: styleProps.opacity, zIndex: zIndexValue }}>
              <ModalInner
                open={open}
                {...propsrest}
                haschildren={`${hasChildren}`}
                style={{
                  ...{
                    height: heightValue,
                    width: widthValue,
                    justifyContent: justifyContentValue,
                    overflow: bodyOverflowVisible ? 'visible' : undefined,
                  },
                  ...styleProps,
                }}
              >
                {this._renderContent()}
              </ModalInner>
            </ModalWrap>
          ))
        }
      </Transition>
    );
  }
}

export default Modal;
